import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface Endereco {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  erro?: boolean;
}

@Injectable({ providedIn: 'root' })
export class viaCep {
  constructor(private http: HttpClient) {}

  buscarPorCep(cep: string): Promise<Endereco> {
    const cepLimpo = cep.replace(/\D/g, '')

    if (cepLimpo.length !== 8) {
      return Promise.reject('CEP inválido')
    }

    return this.http
      .get<Endereco>(`https://viacep.com.br/ws/${cepLimpo}/json/`)
      .toPromise()
      .then(endereco => {
        if (!endereco || endereco.erro) {
          return Promise.reject('CEP não encontrado')
        }
        return endereco
      })
  }
}